import { Link } from "react-router-dom";
import { useAuth } from "../../../providers/AuthProvider";
import { useClient } from "../../../providers/ClientProvider";
import React from "react";


const ProfilePanel = () => {
    const { auth } = useAuth();

    const supplierOrg = useClient();

    const about = supplierOrg.about ? TB.stripHtml(supplierOrg.about) : undefined
    return (
        <div className="w-full mb-6 sm:px-3 md:w-5/12 xl:w-4/12">

            <div className="talent-dashboard-panel">

                <div className="talent-panel-content-container">
                    <div className="talent-panel-section h-full">

                        <div className="w-full flex flex-col justify-between h-full">
                            <div>

                                <div className="flex justify-between items-center">
                                    <p className="text-lg font-semibold">
                                        Agency Profile
                                    </p>

                                    <Link to="/supplier/manage-profile" className="btn btn-link btn-link-primary p-0 text-base">Edit Profile</Link>
                                </div>
                                <div className="flex flex-row items-center gap-3">
                                    <img className="w-[120px] h-[120px]" src={supplierOrg.logo_path} />

                                    <div className="flex flex-col items-start gap-2">
                                        <p className="font-medium text-lg agency-profile-name">{supplierOrg.name}</p>
                                        <p className="text-sm text-wrippleLightDarkest">{supplierOrg.type}</p>
                                    </div>
                                </div>

                                <div className="mt-2 agency-profile-about" dangerouslySetInnerHTML={{ __html: about || '<i>Missing description</i>' }} />

                                <ul className="flex flex-col gap-6 mt-6">
                                    <li>
                                        <i className="fas fa-globe mr-3 text-wrippleLightDarkest" />
                                        {supplierOrg.website ? (
                                            <a className="text-xs text-link-info" target="_blank" href={supplierOrg.website}>{supplierOrg.website}</a>
                                        ) : (
                                            <span className="text-xs">N/A</span>
                                        )}
                                    </li>
                                    <li>
                                        <i className="fas fa-map-marker mr-3 text-wrippleLightDarkest" />
                                        <span className="text-xs">{supplierOrg?.location ? `${supplierOrg.location?.city}, ${supplierOrg.location?.state}` : 'N/A'}</span>
                                    </li>
                                    {supplierOrg.approved_email_domains?.length > 0 && (
                                        <li>
                                            <i className="fas fa-envelope mr-3 text-wrippleLightDarkest" />
                                            <span className="text-xs inline">{TB.join(TB.map(supplierOrg.approved_email_domains || [], email => `@${email}`), ', ')}</span>
                                        </li>
                                    )}
                                </ul>
                            </div>

                            <div className="flex justify-end">
                                <Link
                                    to={`/agency-profiles/${supplierOrg.id}`}
                                    className="btn btn-primary ml-auto self-center"
                                    state={{from: '/supplier/dashboard'}}
                                >
                                    View Client-Facing Agency Profile
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div >
    )
}

export default ProfilePanel;

ProfilePanel.propTypes = {};